import { DefaultOptionType } from 'antd/es/select';
import { stringContainsSubstringCaseInsensitive } from '@sonar-software/sonar-ts-lib';

export function caseInsensitiveContainsFilterOption<T extends DefaultOptionType | undefined>(input: string, option: T) {
	return stringContainsSubstringCaseInsensitive(option?.label as string, input);
}
